import { render, staticRenderFns } from "./AmazonIssues.vue?vue&type=template&id=1876a121"
import script from "./AmazonIssues.vue?vue&type=script&lang=js"
export * from "./AmazonIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports